
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route, NavigationGuardNext } from 'vue-router';
import store from '@/store';
import FondoDiagonal from '@/componentes/UI/FondoDiagonal.vue';
import ProgresoPasos from '@/componentes/ProgresoPasos.vue';
import Eleccion from '@/componentes/pago/Eleccion.vue';
import EleccionModalidad from '@/componentes/pago/EleccionModalidad.vue';
import InformacionPago from '@/componentes/pago/InformacionPago.vue';
import {
  getArancelEstudiante, postAceptarPagare, ArancelEstudianteI, getDetallesPeriodo,
  DetallesPeriodoI,
} from '@/assets/api/matricula';
import { ModalidadCuotaI, getModalidadesCuotas } from '@/assets/api/pagare';
import { postPagoArancel, RespuestaWebpayI, redirectPostWebpay } from '@/assets/api/pagos';
import HeaderPrincipal from "@/componentes/UI/HeaderPrincipal.vue";

@Component({
  components: {
    HeaderPrincipal,
    FondoDiagonal, ProgresoPasos, InformacionPago, Eleccion, EleccionModalidad,
  },
})
export default class PagoArancel extends Vue {
  arancel: ArancelEstudianteI = {} as ArancelEstudianteI;
  dctoOportuno = 0;
  formaPago: number | null = null;
  modalidad: number | null = null;
  modo = 1;
  modalidadesCuotas: ModalidadCuotaI[] = [];
  modalidadCuota = -1;
  detallesPeriodo: DetallesPeriodoI = {} as DetallesPeriodoI;
  cargando = false;
  error = '';

  // Estado específico para flujo Magíster
  modalidadMagister: 'webpay' | null = null;

  // Computed: tipo de programa
  get esMagister(): boolean {
    return this.$store.getters.esMagister;
  }

  // Computed properties for colors
  get planColor(): string {
    const colorVar = this.$store.getters.colorPlan;
    if (colorVar.includes('var(')) {
      const colorMap: Record<string, string> = {
        'var(--azul-institucional)': '#375282',
        'var(--verde-institucional)': '#40b99d',
        'var(--celeste-institucional)': '#56c0e8',
        'var(--azul-enfermeria)': '#273470',
        'var(--rojo-obstetricia)': '#AB2326',
        'var(--verde-agronomia)': '#639244',
        'var(--verde-forestal)': '#136E49',
        'var(--naranjo-industrial)': '#F06A26',
        'var(--amarillo-social)': '#F9b81C',
        'var(--celeste-psicologia)': '#00ACB4',
        'var(--rosado-informatica)': '#D60B51',
        'var(--verde-terapia-ocupacional)': '#336666',
        'var(--azul-ing-comercial)': '#006699',
        'var(--naranjo)': '#f27c08',
        'var(--morado-adm-publica)': '#333366',
        'var(--gris-derecho)': '#666666',
        'var(--amarillo-ing-renovables)': '#8c9c27'
      };
      return colorMap[colorVar] || '#375282';
    }
    return colorVar;
  }

  get planTextColor(): string {
    const colorVar = this.$store.getters.colorTextoPlan;
    if (colorVar.includes('var(')) {
      const colorMap: Record<string, string> = {
        'var(--azul-institucional)': '#375282',
        'var(--verde-institucional)': '#40b99d',
        'var(--celeste-institucional)': '#56c0e8',
        'var(--azul-enfermeria)': '#273470',
        'var(--rojo-obstetricia)': '#AB2326',
        'var(--verde-agronomia)': '#639244',
        'var(--verde-forestal)': '#136E49',
        'var(--naranjo-industrial)': '#F06A26',
        'var(--amarillo-social)': '#F9b81C',
        'var(--celeste-psicologia)': '#00ACB4',
        'var(--rosado-informatica)': '#D60B51',
        'var(--verde-terapia-ocupacional)': '#336666',
        'var(--azul-ing-comercial)': '#006699',
        'var(--naranjo)': '#f27c08',
        'var(--morado-adm-publica)': '#333366',
        'var(--gris-derecho)': '#666666',
        'var(--amarillo-ing-renovables)': '#8c9c27'
      };
      return colorMap[colorVar] || '#375282';
    }
    return colorVar;
  }

  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext<PagoArancel>) {
    const promesaArancel = getArancelEstudiante(store.getters.idEstudiante);
    const promesaDetalles = getDetallesPeriodo(store.getters.idEstudiante);
    const promesaModalidades = getModalidadesCuotas(
      store.getters.idPlan,
      store.getters.esEstudianteAntiguo ? 1 : 0,
    );

    Promise.all([promesaArancel, promesaDetalles, promesaModalidades])
      .then(([arancel, detallesPeriodo, modalidades]) => {
        if (!detallesPeriodo) {
          next({ name: 'resumen' });
          return;
        }
        if ((arancel.orden_compra && arancel.orden_compra.estado_pago === 1)
          || (arancel.pagare && arancel.pagare.estado === 1)) {
          next({ name: 'resumen' });
          return;
        }
        next((vm) => {
          vm.arancel = arancel;
          vm.modalidadesCuotas = modalidades;
          vm.detallesPeriodo = detallesPeriodo;
          vm.dctoOportuno = detallesPeriodo.dctoOportuno;
          if (modalidades.length === 0) {
            vm.formaPago = 1; // solo pago contado si no hay pagarés registrados
          } else {
            vm.modalidadCuota = modalidades[0].id;
          }
        });
      })
      .catch(() => {
        next({ name: store.getters.linkInicio });
      });
  }

  get montoOriginal(): number {
    return this.arancel.monto + this.arancel.beneficios_monto_total;
  }

  get montoBeneficios(): number {
    return this.arancel?.beneficios_monto_total ?? 0;
  }

  get montoArancel(): number {
    return this.arancel?.monto ?? 0;
  }

  get montoDescuento(): number {
    if (this.esMagister) return 0;
    return Math.round(this.arancel.monto * (this.dctoOportuno / 100));
  }

  get montoFinal(): number {
    if (this.esMagister) {
      return this.arancel?.monto ?? 0;
    }
    if (this.formaPago === 1) {
      return this.arancel.monto - this.montoDescuento;
    }
    return this.arancel.monto;
  }

  get tienePagare(): boolean {
    return this.modalidadesCuotas.length > 0;
  }

  // Método para seleccionar Webpay en flujo Magíster
  seleccionarWebpayMagister(): void {
    this.modalidadMagister = 'webpay';
    // Configurar internamente para que enviar() funcione con webpay
    this.formaPago = 1;
    this.modalidad = 1;
    this.modo = 7;
  }

  @Watch('formaPago')
  cambioFormaPago(): void {
    // Solo aplicar lógica automática en flujo no-magíster
    if (this.esMagister) return;
    if (this.formaPago === 2) {
      this.modalidad = 3; // pagaré
    } else {
      this.modalidad = null; // deseleccionar
    }
  }

  @Watch('modalidad')
  cambioModalidad(): void {
    if (this.modalidad === 2) {
      this.modo = 1; // modo presencial
    } else if (this.modalidad === 1) {
      this.modo = 7; // webpay
    }
  }

  async enviar(): Promise<void> {
    if (store.getters.idEstudiante) {
      this.cargando = true;
      this.error = '';

      try {
        // Flujo Magíster
        if (this.esMagister) {
          if (this.modalidadMagister === 'webpay') {
            // Pago por Webpay
            const respuesta = await postPagoArancel({
              estudiante_id: store.getters.idEstudiante,
              forma_pago_id: 7, // webpay
            });
            const respWebpay = respuesta as RespuestaWebpayI;
            redirectPostWebpay(respWebpay.url_redirect, respWebpay.token_webpay);
          } else {
            // Continuar sin pago (consultará a finanzas)
            // Enviar modo caja/presencial para registrar el paso
            await postPagoArancel({
              estudiante_id: store.getters.idEstudiante,
              forma_pago_id: 1, // caja
            });
            store.commit('actualizarEtapa', 4);
            await this.$nextTick();
            this.$router.push({ name: 'resumen' });
          }
          return;
        }

        // Flujo Pregrado / Educación Continua
        if (this.formaPago || this.montoFinal === 0) {
          if (this.formaPago === 1 || this.montoFinal === 0) { // pago contado
            if (this.montoFinal === 0) {
              this.modo = 1;
            }
            const respuesta = await postPagoArancel({
              estudiante_id: store.getters.idEstudiante,
              forma_pago_id: this.modo,
            });
            if (this.modo === 7) {
              const respWebpay = respuesta as RespuestaWebpayI;
              redirectPostWebpay(respWebpay.url_redirect, respWebpay.token_webpay);
            } else {
              store.commit('actualizarEtapa', 4);
              await this.$nextTick();
              this.$router.push({ name: 'resumen' });
            }
          } else { // pagaré
            await postAceptarPagare({
              estudiante: store.getters.idEstudiante,
              modalidad: this.modalidadCuota,
            });
            store.commit('actualizarEtapa', 4);
            await this.$nextTick();
            this.$router.push({ name: 'resumen' });
          }
        }
      } catch (error: any) {
        this.cargando = false;
        if (error.mensaje) {
          this.error = error.mensaje;
        } else {
          this.error = 'Lo sentimos, ha ocurrido un error en el sistema. Por favor intenta nuevamente y si el problema persiste ponte en contacto con el encargado de matrícula';
        }
      }
    }
  }
}
